import React, { useEffect, useState } from "react";
import { Navbar, Container, Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./Header.css";

const Header = () => {
  const { i18n } = useTranslation();
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <header id="header" className={`header d-flex align-items-center fixed-top ${scrolled ? "scrolled" : ""}`}>
      <Container className="d-flex justify-content-between align-items-center">
        <a href="/" className="logo d-flex align-items-center">
          <img
            src="logo/Logo-F1-OP.png"
            alt="Impcaterer Logo"
            height="150"
            className="d-inline-block align-top"
          />
        </a>

        <Dropdown>
          <Dropdown.Toggle variant="outline-light" id="dropdown-basic" size="sm">
            {i18n.language}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={() => handleLanguageChange("EN")}>English</Dropdown.Item>
            <Dropdown.Item onClick={() => handleLanguageChange("CN")}>中文</Dropdown.Item>
            <Dropdown.Item onClick={() => handleLanguageChange("BM")}>BM</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Container>
    </header>
  );
};

export default Header;